import { render, staticRenderFns } from "./happygo_sso.vue?vue&type=template&id=ebc72aa0&scoped=true&"
import script from "./happygo_sso.vue?vue&type=script&lang=js&"
export * from "./happygo_sso.vue?vue&type=script&lang=js&"
import style0 from "./happygo_sso.vue?vue&type=style&index=0&id=ebc72aa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc72aa0",
  null
  
)

export default component.exports